import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import HttpBackend from 'i18next-http-backend';
import LanguageDetector from 'i18next-browser-languagedetector';

export const SUPPORTED_LANGUAGES = ['fr', 'en', 'it', 'es', 'zh'] as const;
export type SupportedLanguage = typeof SUPPORTED_LANGUAGES[number];
export const DEFAULT_LANGUAGE: SupportedLanguage = 'fr';

void i18n
    .use(HttpBackend)
    .use(LanguageDetector)
    .use(initReactI18next)
    .init({
        supportedLngs: SUPPORTED_LANGUAGES as unknown as string[],
        fallbackLng: DEFAULT_LANGUAGE,
        ns: ['common'],
        defaultNS: 'common',
        backend: {
            loadPath: `${process.env.PUBLIC_URL}/locales/{{lng}}/{{ns}}.json`,
        },
        detection: {
            order: ['localStorage', 'navigator'],
            caches: ['localStorage'],
            lookupLocalStorage: 'bart_lang',
        },
        interpolation: {
            escapeValue: false,
        },
        react: {
            useSuspense: true,
        },
    });

i18n.on('languageChanged', (lng) => {
    document.documentElement.lang = lng;
});

// Langue courante normalisée ("en-US" -> "en"), à envoyer aux API qui
// génèrent du contenu localisé (emails notamment).
export const getCurrentLanguage = (): SupportedLanguage => {
    const base = i18n.language?.split('-')[0];
    return (SUPPORTED_LANGUAGES as readonly string[]).includes(base)
        ? (base as SupportedLanguage)
        : DEFAULT_LANGUAGE;
};

export default i18n;
